<template>
  <div class="inv-filterbar">
    <div class="inv-search">
      <span class="inv-search__icon">⌕</span>
      <input
        :value="search"
        class="inv-search__input"
        placeholder="Search by name, serial number, model..."
        @input="$emit('update:search', $event.target.value)"
      />
      <span v-if="search" class="inv-search__clear" @click="$emit('update:search', '')">×</span>
    </div>
    <div class="inv-filters">
      <div
        v-for="opt in typeOptions"
        :key="'t' + opt.value"
        class="inv-filter-chip"
        :class="{ 'inv-filter-chip--active': filterType === opt.value }"
        :style="filterType === opt.value ? { backgroundColor: typeHex(opt.value), color: '#fff' } : {}"
        @click="$emit('update:filterType', filterType === opt.value ? null : opt.value)"
      >
        <span class="inv-filter-chip__dot" :style="{ background: filterType === opt.value ? '#fff' : typeHex(opt.value) }"></span>
        {{ opt.text }}
      </div>
      <div class="inv-filter-sep">|</div>
      <div
        v-for="opt in statusOptions"
        :key="'s' + opt.value"
        class="inv-filter-chip"
        :class="{ 'inv-filter-chip--active': filterStatus === opt.value }"
        @click="$emit('update:filterStatus', filterStatus === opt.value ? null : opt.value)"
      >
        {{ opt.text }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ToolsFilterBar',
  props: {
    search:       { type: String,  default: '' },
    filterType:   { type: Number,  default: null },
    filterStatus: { type: Number,  default: null },
    typeOptions:  { type: Array,   required: true },
    statusOptions:{ type: Array,   required: true },
  },
  methods: {
    typeHex(v) { return { 1: '#f59e0b', 2: '#3b82f6' }[v] || '#94a3b8' },
  },
}
</script>

<style scoped>
.inv-filterbar {
  padding: 14px 28px;
  background: var(--bg2);
  border-bottom: 1px solid var(--border);
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}
.inv-search {
  position: relative;
  display: flex;
  align-items: center;
  flex: 0 0 340px;
}
.inv-search__icon  { position: absolute; left: 10px; color: var(--text-dim); font-size: 21px; }
.inv-search__input {
  width: 100%;
  background: var(--bg3);
  border: 1px solid var(--border);
  color: var(--text);
  font-family: 'IBM Plex Mono', monospace;
  font-size: 15px;
  padding: 8px 32px 8px 36px;
  outline: none;
  transition: border-color 0.15s;
}
.inv-search__input::placeholder { color: var(--text-dim); }
.inv-search__input:focus { border-color: var(--accent); }
.inv-search__clear {
  position: absolute; right: 10px;
  color: var(--text-dim); cursor: pointer; font-size: 21px;
}
.inv-search__clear:hover { color: var(--text); }
.inv-filters { display: flex; align-items: center; gap: 6px; flex-wrap: wrap; }
.inv-filter-sep { color: var(--border2); margin: 0 6px; }
.inv-filter-chip {
  display: flex; align-items: center; gap: 5px;
  font-family: 'IBM Plex Mono', monospace;
  font-size: 13px; font-weight: 500; letter-spacing: 0.05em;
  padding: 6px 12px;
  border: 1px solid var(--border);
  cursor: pointer;
  color: var(--text-dim);
  background: var(--bg3);
  transition: all 0.12s;
  user-select: none;
}
.inv-filter-chip:hover { border-color: var(--border2); color: var(--text); }
.inv-filter-chip--active { border-color: var(--accent); color: var(--accent2); background: rgba(79,142,255,0.08); }
.inv-filter-chip__dot { width: 7px; height: 7px; border-radius: 50%; flex-shrink: 0; }

/* ── RESPONSIVE ── */
@media (max-width: 768px) {
  .inv-filterbar {
    padding: 12px 16px;
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }
  .inv-search { flex: 1 1 100%; }
  .inv-filters { gap: 6px; }
  .inv-filter-sep { display: none; }
  .inv-filter-chip { font-size: 12px; padding: 6px 10px; }
}

@media (max-width: 480px) {
  .inv-filterbar { padding: 10px 12px; }
  .inv-search__input { font-size: 14px; }
  .inv-filter-chip { font-size: 11px; padding: 5px 8px; }
}
</style>